//------------- REACT IMPORT ---------------//
// import React, { useState } from "react";
// //---------- FONTAWESOME IMPORT ------------//

// //-------- BOOTSTRAP ITEMS IMPORT ----------//
// import { Button, Card, Col, Container, Form, Image, Row, Table } from "react-bootstrap";
// import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
// //------------ CONSTANTS IMPORT ------------//
// import * as Constants from "../../../../Helper/constants/constants";
// import { AssignImg, Circle_Img, Delete_2, Edit_2, Eye_2, Filter, Filters, No_Data } from "../../../../../assets/images";
// import { GirlImg } from "../../../../../assets/images";
// import CustomTab from "../../../../Helper/customTabs";
// import Task from "../../../Tabs/Task";
// import Logs from "../../../Tabs/Logs";
// import NoDataComponent from "../../../CommanComponents/NoDataComponent";
// import { Dropdown } from "bootstrap";
// import { faCircle, faEllipsisVertical, faSearch } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


// const StaffList = () => {
//     var breadcrumData = ["Dashboard", "Manage Staff", "Staff List"];
//     var breadcrumItem = "View Staff Detail";
//     const [searchInput, setSearchInput] = useState("");
//     const handleChange = (e) => {
//         setSearchInput(e.target.value);
//     };
//     const [showFilterModal, setShowFilterModal] = useState(false);
//     return (
//         <div className="staff_detail_section">
//             <WithoutImageHeader
//                 header={Constants.STAFF_LIST}
//                 breadcrumData={breadcrumData}
//                 breadcrumItem={breadcrumItem}
//             />
//             <Container>
//                 <Row>
//                     <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
//                         <div className="staff_list_area">
//                             {/* <div className="task_list_details"> */}
//                             <div className="title_btn_area">
//                                 <div className="left_area">
//                                     <p>Task List</p>
//                                 </div>
//                                 <div className="right_area">
//                                     <Button className="btn" type="submit">
//                                         Add Task
//                                     </Button>
//                                 </div>
//                             </div>
//                             <div className="search_section">
//                                 <div className="search_area">
//                                     <Form>
//                                         <Form.Group className="form-group">
//                                             <Form.Control
//                                                 type="text"
//                                                 placeholder="Search"
//                                                 value={searchInput}
//                                                 onChange={handleChange}
//                                             />
//                                             <a href="javascript:;">
//                                                 <div className="icon">
//                                                     <FontAwesomeIcon icon={faSearch} />
//                                                 </div>
//                                             </a>
//                                         </Form.Group>
//                                     </Form>
//                                 </div>
//                                 <div className="pagination_list">
//                                     <Form>
//                                         <Form.Group className="form-group">
//                                             <Form.Select>
//                                                 <option>5</option>
//                                                 <option>10</option>
//                                                 <option>15</option>
//                                                 <option>20</option>
//                                                 <option>25</option>
//                                             </Form.Select>
//                                         </Form.Group>
//                                     </Form>
//                                 </div>

//                                 <div className="filter_button">
//                                     <Button className="btn-primary" onClick={() => setShowFilterModal(true)}>
//                                         <Image src={Filters} alt="..." className="image_area" />
//                                         Filters</Button>
//                                     <FontAwesomeIcon icon={faCircle} className="filter_icon" />
//                                 </div>

//                             </div>
//                             <div className="list_detail">
//                                 <div className="list_data">
//                                     <Card>
//                                         <Card.Body>
//                                             <Table responsive>
//                                                 <tr>
//                                                     <th>Patient Name</th>
//                                                     <th>Task Title</th>
//                                                     <th>Assigned by</th>
//                                                     <th>Task Priority</th>
//                                                     <th>Status</th>
//                                                     <th>Action</th>
//                                                 </tr>
//                                                 <tr >
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="designation">Cardiology</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td className="title">Test</td>
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="consultant">Consultant</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_high">
//                                                             <p>High</p>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_complete">
//                                                             <p>Complete</p>
//                                                         </div>
//                                                     </td>
//                                                     <td>
//                                                         <div className="icon">
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="none" id="dropdown-basic">
//                                                                     <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
//                                                                 </Dropdown.Toggle>

//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">
//                                                                         Edit
//                                                                         <Image src={Edit_2} alt="..." className="image_area" />
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">Delete
//                                                                         <Image src={Delete_2} alt="..." className="image_area delete_icon " />
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                                 <tr >
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="designation">Cardiology</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td className="title">Test</td>
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="consultant">Consultant</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_high">
//                                                             <p>High</p>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_complete">
//                                                             <p>Complete</p>
//                                                         </div>
//                                                     </td>
//                                                     <td>
//                                                         <div className="icon">
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="none" id="dropdown-basic">
//                                                                     <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
//                                                                 </Dropdown.Toggle>

//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">
//                                                                         Edit
//                                                                         <Image src={Edit_2} alt="..." className="image_area" />
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">Delete
//                                                                         <Image src={Delete_2} alt="..." className="image_area delete_icon " />
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                                 <tr >
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="designation">Cardiology</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td className="title">Test</td>
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="consultant">Consultant</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_low">
//                                                             <p>High</p>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_complete">
//                                                             <p>Complete</p>
//                                                         </div>
//                                                     </td>
//                                                     <td>
//                                                         <div className="icon">
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="none" id="dropdown-basic">
//                                                                     <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
//                                                                 </Dropdown.Toggle>

//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">
//                                                                         Edit
//                                                                         <Image src={Edit_2} alt="..." className="image_area" />
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">Delete
//                                                                         <Image src={Delete_2} alt="..." className="image_area delete_icon " />
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                                 <tr >
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="designation">Cardiology</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td className="title">Test</td>
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="consultant">Consultant</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_high">
//                                                             <p>High</p>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_complete">
//                                                             <p>Complete</p>
//                                                         </div>
//                                                     </td>
//                                                     <td>
//                                                         <div className="icon">
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="none" id="dropdown-basic">
//                                                                     <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
//                                                                 </Dropdown.Toggle>

//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">
//                                                                         Edit
//                                                                         <Image src={Edit_2} alt="..." className="image_area" />
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">Delete
//                                                                         <Image src={Delete_2} alt="..." className="image_area delete_icon " />
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                                 <tr >
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="designation">Cardiology</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td className="title">Test</td>
//                                                     <td >
//                                                         <div className="data_table">
//                                                             <div className="left_area">
//                                                                 <div className="img_area">
//                                                                     <Image src={AssignImg} alt="..." />
//                                                                 </div>
//                                                             </div>
//                                                             <div className="right_areaa">
//                                                                 <a href="javascript:;">
//                                                                     Robert William
//                                                                 </a>
//                                                                 <p><span className="consultant">Consultant</span></p>
//                                                             </div>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_low">
//                                                             <p>High</p>
//                                                         </div>
//                                                     </td>
//                                                     <td >
//                                                         <div className="badge_complete">
//                                                             <p>Complete</p>
//                                                         </div>
//                                                     </td>
//                                                     <td>
//                                                         <div className="icon">
//                                                             <Dropdown>
//                                                                 <Dropdown.Toggle variant="none" id="dropdown-basic">
//                                                                     <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
//                                                                 </Dropdown.Toggle>

//                                                                 <Dropdown.Menu>
//                                                                     <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">
//                                                                         Edit
//                                                                         <Image src={Edit_2} alt="..." className="image_area" />
//                                                                     </Dropdown.Item>
//                                                                     <Dropdown.Item href="javascript:;">Delete
//                                                                         <Image src={Delete_2} alt="..." className="image_area delete_icon " />
//                                                                     </Dropdown.Item>
//                                                                 </Dropdown.Menu>
//                                                             </Dropdown>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             </Table>
//                                         </Card.Body>
//                                     </Card>
//                                 </div>
//                             </div>
//                             {/* </div> */}
//                         </div>
//                     </Col>
//                 </Row>
//             </Container>
//         </div >
//     );
// };

// export default StaffList;

import React, { useState } from "react";
//---------- FONTAWESOME IMPORT ------------//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Card, Col, Container, Dropdown, Form, Image, Row, Table } from "react-bootstrap";
import { faCircle, faEllipsisVertical, faSearch } from "@fortawesome/free-solid-svg-icons";
import { AssignImg, Delete_2, Edit_2, Eye_2, Filters } from "../../../../../assets/images";
import FiltersHeader from "../../../../Helper/filtersHeader";
import * as Constants from "../../../../Helper/constants/constants";
import PaginationComponent from "../../../CommanComponents/Pagination";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";

const StaffList = () => {
    const [searchInput, setSearchInput] = useState("");
    const handleChange = (e) => {
        setSearchInput(e.target.value);
    };
    const [showFilterModal, setShowFilterModal] = useState(false);
    var breadcrumData = ["Dashboard", "Manage Staff"];
    var breadcrumItem = "Staff List";
    return (
        <div className="task_list_screen staff_list_section">
            <WithoutImageHeader
                header={Constants.STAFF_LIST}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="task_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>Employee List</p>
                                </div>
                                <div className="right_area">
                                    <Button className="btn" type="submit">
                                        Add Employee
                                    </Button>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                                value={searchInput}
                                                onChange={handleChange}
                                            />
                                            <a href="javascript:;">
                                                <div className="icon">
                                                    <FontAwesomeIcon icon={faSearch} />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="pagination_list">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Select>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </div>

                                <div className="filter_button">
                                    <Button className="btn-primary" onClick={() => setShowFilterModal(true)}>
                                        <Image src={Filters} alt="..." className="image_area" />
                                        Filters</Button>
                                    <FontAwesomeIcon icon={faCircle} className="filter_icon" />
                                </div>

                            </div>
                            <div className="list_detail">
                                <div className="list_data">
                                    <Card>
                                        <Card.Body>
                                            <Table responsive>
                                                <tr>
                                                    <th>Patient Name</th>
                                                    <th>Task Title</th>
                                                    <th>Assigned by</th>
                                                    <th>Task Priority</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                                <tr >
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="designation">Cardiology</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="title">Test</td>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="consultant">Consultant</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_high">
                                                            <p>High</p>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_complete">
                                                            <p>Complete</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr >
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="designation">Cardiology</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="title">Test</td>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="consultant">Consultant</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_high">
                                                            <p>High</p>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_complete">
                                                            <p>Complete</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr >
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="designation">Cardiology</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="title">Test</td>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="consultant">Consultant</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_low">
                                                            <p>High</p>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_complete">
                                                            <p>Complete</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr >
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="designation">Cardiology</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="title">Test</td>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="consultant">Consultant</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_high">
                                                            <p>High</p>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_complete">
                                                            <p>Complete</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr >
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="designation">Cardiology</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="title">Test</td>
                                                    <td >
                                                        <div className="data_table">
                                                            <div className="left_area">
                                                                <div className="img_area">
                                                                    <Image src={AssignImg} alt="..." />
                                                                </div>
                                                            </div>
                                                            <div className="right_areaa">
                                                                <a href="javascript:;">
                                                                    Robert William
                                                                </a>
                                                                <p><span className="consultant">Consultant</span></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_low">
                                                            <p>High</p>
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div className="badge_complete">
                                                            <p>Complete</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="icon">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">View <Image src={Eye_2} alt="..." className="image_area" /></Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">
                                                                        Edit
                                                                        <Image src={Edit_2} alt="..." className="image_area" />
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Delete
                                                                        <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <PaginationComponent />
        </div>
    );
};

export default StaffList;


